import styled from 'styled-components'
import media from 'utils/media'

export const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  margin-top: 78px;
  padding: 0 50px;
  max-width: 1024px;
  background-color: ${p => p.theme.colors.gray7};

  ${media.screen`
    margin-top: ${props => (props.isOffline ? '54px' : '0')};
    padding: 0;
    width: 100%;
    max-width: 100%;
  `}
`

export const ErrorNoteContainer = styled.div`
  background-color: #fff;
  padding: 15px;
  margin-bottom: 300px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
`

export const ErrorNoteTitle = styled.h4`
  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  margin-bottom: 5px;
`

export const ErrorNoteDescrption = styled.div`
  font-family: 'Montserrat', sans-serif !important;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 5px;
`

export const ErrorNoteLink = styled.a`
  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${props => props.theme.colors.orange};
  text-decoration: none;
`

export const ImgsContainer = styled.div`
  position: relative;
`

export const InfoSectionImgAbs = styled.div`
  display: flex;
  position: absolute;
  bottom: 12px;
  left: 12px;
  border: 2px solid #ffffff;
  border-radius: 50%;
`

export const OrderPartyButton = styled.div`
  position: absolute;
  right: 30px;
  top: 30px;
`
